<template>
  <div class="footer__gofun">
    <div class="footer__gofun-redirect">
      <div class="footer__gofun-logo">
        <icon-gofun />
      </div>
      <div class="footer__gofun-links">
        <a
          href="http://goca.se/gofunandroid"
          title="Disponível no Google Play"
          target="_blank"
          rel="noopener"
        >
          <icon-playstore />
        </a>
        <a
          href="http://goca.se/gofunapple"
          title="Disponível na Apple Store"
          target="_blank"
          rel="noopener"
        >
          <icon-appstore />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import IconPlaystore from '~/components/icons/footer-gofun/icon-playstore/Playstore'
import IconAppstore from '~/components/icons/footer-gofun/icon-appstore/Appstore'
import IconGofun from '~/components/icons/footer-gofun/icon-gofun/Gofun'

export default {
  name: 'FooterGofun',
  components: {
    IconPlaystore,
    IconAppstore,
    IconGofun,
  },
}
</script>

<style lang="scss" scoped>
.footer__gofun-redirect {
  display: flex;
}

.footer__gofun-logo {
  width: 102px;
  flex-shrink: 0;
  margin-right: 2 * $v4_gutter;
}

.footer__gofun-links {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  a {
    margin-bottom: 2 * $v4_gutter;

    svg {
      display: block;
    }

    &:hover {
      opacity: 0.8;
    }
  }
}

@media (max-width: $screen_large) {
  .footer__gofun-redirect {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .footer__gofun-subtitle {
    text-align: center;
    margin-bottom: 15px;
  }

  .footer__gofun-logo {
    svg {
      display: block;
    }
  }
  .footer__gofun-links a:last-child {
    margin-bottom: 0;
  }
}

@media (min-width: $screen_large) {
  .footer__gofun {
    display: none;
  }
}
</style>
